export enum LoyaltyStatusVariant {
	Page = 'PageStatus',
	Summary = 'SummaryStatus',
}
